import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appPanFormat]'
})
export class PanFormatDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  // @HostListener('input', ['$event'])
  // onInput() {
  //   const input = this.el.nativeElement;
  //   // Remove non-alphanumeric characters and convert to uppercase
  //   const cleaned = input.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

  //   if (input.value !== cleaned) {
  //     input.value = cleaned;
  //     input.dispatchEvent(new Event('input', { bubbles: true }));
  //   }
  // }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    if (allowedKeys.includes(event.key)) return;

    // Only allow alphanumeric characters
    if (!/^[a-zA-Z0-9]$/.test(event.key)) event.preventDefault();

    // Max 10 characters
    if (this.el.nativeElement.value.length >= 10) event.preventDefault();
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') ?? '';
    // Only alphanumeric, max 10
    if (!/^[a-zA-Z0-9]+$/.test(pasted) || (this.el.nativeElement.value.length + pasted.length) > 10) {
      event.preventDefault();
    }
  }
}
